// @ts-ignore
import _ from 'lodash';
// @ts-ignore
import html2canvas from 'html2canvas-1';
// @ts-ignore
import {fetchMarkImageApi} from '../../../../apis/core_basic_api/image';

const EXPORT_IMAGE_NAME = 'drawing';


export default async function downloadImage(options: {
    patentId: string,
    imagePath: string,
    imageLoaderId: string,
}, downloadStateCallback: (s: boolean) => void) {
    const {patentId, imagePath, imageLoaderId} = options;
    const imageWrapperSelector = `[data-image-loader-id="${imageLoaderId}"]`;

    downloadStateCallback(true);
    const container = document.querySelector(imageWrapperSelector);

    if (!container) {
        downloadStateCallback(false);
        return;
    }

    const {
        width,
        height
    } = container.getBoundingClientRect();

    // 获取图片base64
    const imageBase64 = await fetchMarkImageApi(imagePath, patentId)
        .then((res: any) => {
            return _.get(res, 'image_base64');
        });

    if (!imageBase64) {
        downloadStateCallback(false);
        return;
    }
    // data-html2canvas-ignore="true"的元素将不会被svg下载
    await html2canvas(container, {
        width,
        height,
        scale: 1,
        onclone: async (doc: HTMLElement) => {

            // 截图专有样式
            doc.querySelectorAll(`${imageWrapperSelector} .label-box`)
                .forEach(function (labelBox: Element) {
                    // @ts-ignore
                    labelBox.style.paddingBottom = '8px';
                })


            const onloadImageBase64 = function () {
                return new Promise((resolve) => {
                    const imgTag = doc.querySelector(`${imageWrapperSelector} .image-img`);
                    imgTag!.addEventListener('load', resolve)
                    imgTag!.setAttribute('src', `data:image/png;base64,${imageBase64}`);
                });
            };
            await onloadImageBase64();
        },
    })
        .then((canvas: HTMLCanvasElement) => {
            // logo合成
            /* const logo = new Image();
            logo.src = require('../../../assets/images/patsnap-logo.png');
            logo.style.width = LOGO_SIZE.width;
            logo.style.height = LOGO_SIZE.height;
            const logoLoad = function() {
                return new Promise((resolve) => {
                    logo.onload = function () {
                        console.log(canvas.width, canvas.height);
                        const ctx = canvas.getContext('2d');
                        const a = width / height;
                        console.log(a, height * a, width * a);
                        ctx.drawImage(logo, 0, 0, LOGO_SIZE.width, LOGO_SIZE.height);
                        resolve(canvas);
                    };
                    logo.onerror = function() {
                        resolve(canvas);
                    };
                });
            };
            return logoLoad(); */
            return canvas as HTMLCanvasElement;
        })
        .then((canvas: HTMLCanvasElement) => {
            const filename = `${EXPORT_IMAGE_NAME}.png`;
            canvas.id = 'image-loader-for-export';
            const saveLink = document.createElement('a');
            saveLink.setAttribute('class', 'hide');
            saveLink.setAttribute('download', 'filename');
            saveLink.href = canvas.toDataURL('image/png');
            saveLink.download = filename;
            document.body.appendChild(saveLink);
            saveLink.click();
            document.body.removeChild(saveLink);
        })
        .catch((err: Error) => {
            console.log(err);
        })
        .finally(() => {
            downloadStateCallback(false);
        });
}
